import { NavigationButton as NavigationButtonType } from '@/schemas/sceneDataSchema';
import { RouteFn } from '@/hooks/use-flow';
import { ComponentButton } from './ComponentButton';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const NavigationButton = ({ component, route }: { component: NavigationButtonType; route: RouteFn }) => {
  const { trackClick } = useAnalytics();

  const onClick = () => {
    trackClick(eventName(component.id), { step_id: component.step_id, button_type: component.type });
    void route(component.entity_index, component.step_id);
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
